import { pick } from 'lodash-es'
import moment from 'moment-timezone'

import { convertHostIdsToMeetingRoles } from 'components/meetings/filter_modal/utils'
import { useScope } from 'hooks/meetings/use_scope'

import { useLookupUuidsQuery } from './api'
import { STATUS_MAP, Statuses } from '../../services/search_api/constants'

const dateRangeFilter = (params) => {
  switch (params.period) {
    case 'fixed':
      return {
        operation: 'BETWEEN',
        start: moment(params.start).startOf('day').toISOString(),
        end: moment(params.end).endOf('day').toISOString(),
      }
    case 'today':
      return {
        operation: 'BETWEEN',
        start: moment().startOf('day').toISOString(),
        end: moment().endOf('day').toISOString(),
      }
    case 'this_week':
      return {
        operation: 'BETWEEN',
        start: moment().startOf('week').toISOString(),
        end: moment().endOf('week').toISOString(),
      }
    case 'this_month':
      return {
        operation: 'BETWEEN',
        start: moment().startOf('month').toISOString(),
        end: moment().endOf('month').toISOString(),
      }
    case 'this_year':
      return {
        operation: 'BETWEEN',
        start: moment().startOf('year').toISOString(),
        end: moment().endOf('year').toISOString(),
      }
    default:
      return null
  }
}

const useFilterParamsWithUuids = (filterParams) => {
  const { data: uuids } = useLookupUuidsQuery({ filters: filterParams })

  if (!uuids) {
    return filterParams
  }

  return {
    ...filterParams,
    ...uuids,
  }
}

const buildStatuses = ({ status }) => {
  if (!status || status.length === 0 || status.includes(Statuses.ALL)) return null

  const statusValues = status
    .map((s) => STATUS_MAP[s])
    .filter(Boolean)

  return statusValues.length > 0 ? statusValues : null
}

export const useToPrepareSearchFiltersParams = (filters) => {
  const { scopeType, scopeId } = useScope()
  const hydratedFilters = useFilterParamsWithUuids(filters)
  const { dateRange, ...restFilters } = hydratedFilters

  const mappedRoles = convertHostIdsToMeetingRoles(restFilters.role, scopeType, scopeId)

  const kinds = restFilters.schedulingMethod?.map((method) => method.toUpperCase()) || []

  const statuses = buildStatuses(restFilters)

  return {
    ...pick(restFilters, ['searchIn', 'inviteeEmails']),
    ...(kinds.length > 0 && { kinds }),
    ...(statuses && { statuses }),
    ...(mappedRoles && mappedRoles.length > 0 && { role: mappedRoles }),
    startTimeRange: dateRangeFilter(dateRange),
    eventTypeUuids: restFilters.eventTypeIds,
    packageUuids: restFilters.packageUuids,
  }
}
